<div
  class="simple-callout flex items-start overflow-clip rounded-2xl border"
  [ngClass]="[customCss(), colorClasses().border, colorClasses().bg]"
>
  <div class="flex flex-1 flex-col gap-2 p-4 md:gap-3 md:p-4">
    <div class="flex items-center gap-2" contenteditable="false">
      <div class="shrink-0">
        <dojo-icon [icon]="icon()" [ngClass]="colorClasses().text" [size]="14" />
      </div>
      <span
        #titleElement
        class="text-xs font-bold uppercase leading-4 outline-none"
        [ngClass]="colorClasses().text"
        [attr.contenteditable]="isEditable()"
        (focus)="onTitleFocus()"
        (blur)="onTitleBlur()"
        (input)="updateTitle($event)"
        (keydown)="$event.stopPropagation()"
        (keydown.enter)="$event.preventDefault()"
        dojoStopPropagation
      ></span>
      @if (isEditable()) {
        <div class="ml-auto" dojoStopPropagation>
          <dojo-single-select
            [formCtrl]="variantCtrl"
            [options]="variantOptions"
            optionLabel="label"
            optionValue="value"
            [compact]="true"
            [hideErrors]="true"
            [size]="'s'"
            panelClass="variant-picker-panel"
            (selectionChange)="updateVariant($event)"
            [hideSingleSelectionIndicator]="true"
          >
            <ng-template [dojoSelectOption]="selectOptionType" let-variantOption>
              <div class="flex items-center gap-2">
                <div class="h-3 w-3 shrink-0 rounded-full" [ngClass]="variantOption.pickerColor"></div>
                <span class="whitespace-nowrap text-xs">{{ variantOption.label }}</span>
              </div>
            </ng-template>

            <ng-template [dojoSelectTrigger]="selectOptionType" let-variantOption>
              <div class="flex items-center gap-1.5">
                <div class="h-3 w-3 shrink-0 rounded-full" [ngClass]="variantOption?.pickerColor"></div>
                <span class="whitespace-nowrap text-xs">{{ variantOption?.label }}</span>
              </div>
            </ng-template>
          </dojo-single-select>
        </div>
      }
    </div>

    <div class="simple-callout-content" tiptapNodeViewContent></div>
  </div>
</div>
